import { module } from 'angular';
import PasswordChangeComponent from './password-change/password-change.component';
import './password-change/password-change.scss';

export default module('app')
	.component('passwordChange', PasswordChangeComponent)
	.name;
